module.exports = __webpack_public_path__ + "static/baby-186ee2ef8c5959505da8e1d4feb93fd4.jpg";